<h2 mat-dialog-title>Error Details</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <br />
  <td-message
    label="The operation you attempted was not successful. Application support has been notified. If you need further support, please include the details below."
    color="warn"
    icon="error"
  ></td-message>
  <br />
  <p>
    <mat-form-field (click)="copyActivityId($event)">
      <input matInput placeholder="Activity ID" readonly [formControl]="operationIdCtrl" />
      <mat-icon matSuffix>assignment</mat-icon>
    </mat-form-field>
  </p>
  <textarea style="cursor: pointer" (click)="copy()" *ngIf="details" readonly spellcheck="off">
    {{ details }}
  </textarea>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="copy()" color="primary">
    Copy to clipboard&nbsp;
    <mat-icon>assignment</mat-icon>
  </button>
  <!--
    The mat-dialog-close directive optionally accepts a value as a result for the dialog.
  -->
  <button mat-button [mat-dialog-close]="true">Cancel</button>
</mat-dialog-actions>
